import * as React from 'react'

export const DropdownContext = React.createContext<{
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  value?: any
  placeholder?: string
  onSelect: (value: string | number, node: React.ReactNode, isOnChange?: boolean) => void
  isOpen: boolean
  setScrollTop: (value: number) => void
} | null>(null)
